import config from 'config';
const { HUB_PREFIX } = config;

export const getOriginHub = () => {
  return window.location.origin + HUB_PREFIX;
};
